import PropTypes from 'prop-types';
import React from 'react';
import { Message } from '@weezevent/nacre';
import Styles from '../../../styles/rate/rateList.module.css';
import { formatDateTime } from '../../../utils/date';
import { Trans } from 'react-i18next';
import i18n from 'i18next';

function ConditionalMessage({ condition, type = 'warning', text }) {
    return (
        condition && (
            <Message title="" type={type}>
                {text}
            </Message>
        )
    );
}

ConditionalMessage.propTypes = {
    condition: PropTypes.bool,
    text: PropTypes.node.isRequired,
    type: PropTypes.string
};

export default function Messages({ event, rates, settings, type }) {
    return (
        <div className={Styles['conditional-message']}>
            <ConditionalMessage type={type} condition={event.status === 'draft'} text={<Trans i18nKey="ticket.rates.messageEventDraft" />} />
            <ConditionalMessage
                type={type}
                condition={rates.every(rate => rate.disabled) && event.status === 'published'}
                text={<Trans i18nKey="ticket.rates.messageHiddenRates" />}
            />
            <ConditionalMessage
                type={type}
                condition={event.status === 'published' && event.end_date && new Date(event.end_date) < new Date()}
                text={<Trans i18nKey="ticket.rates.messageEventFinished" />}
            />
            <ConditionalMessage
                type={type}
                condition={event.status === 'published' && settings.start_sale && new Date(settings.start_sale) > new Date()}
                text={
                    <Trans
                        i18nKey="ticket.rates.messageEventPublishedFuture"
                        values={{ date: settings.start_sale ? formatDateTime(settings.start_sale, event.timezone, i18n.language) : null }}
                    />
                }
            />
            <ConditionalMessage
                type={type}
                condition={event.status === 'published' && settings.end_sale && new Date(settings.end_sale) < new Date()}
                text={<Trans i18nKey="ticket.rates.messageEventPublishedPast" />}
            />
        </div>
    );
}

Messages.propTypes = {
    event: PropTypes.object.isRequired,
    rates: PropTypes.array.isRequired,
    settings: PropTypes.object.isRequired,
    type: PropTypes.string
};
